module.exports = __webpack_public_path__ + "img/c010_2.ff7cd3aa.jpg";